import React from 'react';
import Educator from './Educator';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'educator';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <Educator
        key={`${type}-${index}`}
        user={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
